<template>
  <div id="app">
    <router-view />
    <BackToTop />

    <!-- <div class="loading-box df aic jcc" v-if="loadingFlog">
      <p>{{ $t('加载中') }} <img src="@/assets/images/img/loader.gif" alt=""></p>
    </div> -->
  </div>
</template>

<script>
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import { getUrlLocale } from '@/utils/url';
import Cookies from 'js-cookie';

export default {
  name: "App",
  // watch: {
  //   $route: {
  //     handlder(to, from) {
  //       console.log("pc APP", to);
  //     },
  //     immdediate: true,
  //   },
  // },
  data() {
    return {};
  },

  created() {},
  mounted() {


    // this.$i18n.locale = lang; // 修改当前语言

    let Language = localStorage.getItem('currentLanguage');  //获取本地语言

    if (Language && Language != 'zh') {
      locale.use(lang)
    }

    if (Language) {
      this.$i18n.locale = Language;
    } else {
      this.$i18n.locale = "zh";
    }
    document.addEventListener("visibilitychange", this.onVisibilitychange);
  },
  unmounted() {
    document.removeEventListener("visibilitychange", this.onVisibilitychange);
  },

  methods: {
    onVisibilitychange(v) {
      if (document.hidden) {
        console.log("页面隐藏");
      } else {
        // 设置缓存为当前路径对应语言的缓存
        let locale = getUrlLocale();
        if(locale == 'cn') {
          locale = 'zh'
        }
  
        // 更改语言
        this.$i18n.locale = locale;

        // 更改cookie
        const siteDataList = {
          en: '{"tws_id":2,"apply_site":"protal_en"}',
          zh: '{"tws_id":1,"apply_site":"protal"}'
        }
        Cookies.set('siteData', siteDataList[locale]);

        // 更改本地缓存
        localStorage.setItem('currentLanguage', locale);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.loading-box {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;

  p {
    text-align: center;
    // font-size: 3.27vw;
    font-family: "harmonyos";
    color: #666666;
    margin-right: 2vw;
  }

  img {
    width: 24px;
  }
}
</style>
